// extracted by mini-css-extract-plugin
module.exports = {"stickyHeader":"RegistrationsTable_stickyHeader_2r9KO","q-table__top":"RegistrationsTable_q-table__top_2PaUO","q-table__bottom":"RegistrationsTable_q-table__bottom_1UhT6"};